import React from 'react'
import './LinePerMonitor.css';
import { Row, Col, Table, Card, Typography } from 'antd';
const { Paragraph, Text } = Typography;
const LineCards = ({ dataname, price }) => {
    return (
        <div>
            <Row className='mm'>

                <Col md={16}>{dataname}</Col>
                <Col md={2}>|</Col>
                <Col style={{ color: 'blue' }} md={3}>{price}</Col>


                {/* <Text className='f-size15'  ><strong style={{ marginRight: '10px' }}>{dataname} </strong> | <span style={{ color: 'blue', marginLeft: '30%' }}>{price}</span></Text> */}
            </Row>
        </div>
    )
}

export default LineCards